<ng-container *ngIf="isDialogOpened">
  <kendo-window [title]="translationKeyTitle"
                [minWidth]="660"
                [width]="660"
                [minHeight]="235"
                (close)="cancel()"
                class="top-left-counter-card k-window-content min-height-150 confirm-dialog app-confirm-dialog">
    <div class="ContentContainer">
      <table aria-hidden="true">
        <tr>
          <td class="alignLeft">
            <img src="./assets/images/info.png" alt="info" style="max-height: 42px;" />
          </td>
          <td class="dialogConfirmMessage pl-20">
            <span *ngIf="!customMessage">{{ translationKeyMessage }}</span>
            <div *ngIf="customMessage" [innerHTML]="customMessage"></div>
          </td>
        </tr>
      </table>
    </div>
    <div class="dialogButtonBar">
      <div class="reportDesignerButtonBarBorder">
        <div class="ButtonBar">
          <button *ngIf="showConfirmButton" class="k-button ButtonWidth_90px" (click)="confirm()">{{ translationKeyConfirm }}</button>
          <button *ngIf="!!translationKeyCancel" class="k-button ButtonWidth_90px ml-5" (click)="cancel()">{{ translationKeyCancel }}</button>
        </div>
      </div>
    </div>
  </kendo-window>
  <div class="k-overlay overlay-confirm-dialog"></div>
</ng-container>
